import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './AdminTables.css';

const AdminProperties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(getApiUrl('/api/admin/properties'), { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) setProperties(json.properties || []);
        else setError(json.message);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading && properties.length === 0) {
    return (
      <div className="admin-page-loading">
        <div className="admin-spinner" />
        <p>Loading properties...</p>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Property Overview</h2>
      <p className="admin-page-subtitle">All listed accommodations with booking count and ratings.</p>
      {error && <div className="admin-page-error">{error}</div>}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Property</th>
              <th>City</th>
              <th>Type</th>
              <th>Price/night</th>
              <th>Bookings</th>
              <th>Avg rating</th>
              <th>Reviews</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {properties.map((p) => (
              <tr key={p._id}>
                <td>{p.name || '—'}</td>
                <td>{p.city || '—'}</td>
                <td>{p.type || '—'}</td>
                <td>₹{(p.pricePerNight ?? 0).toLocaleString()}</td>
                <td>{p.bookingCount ?? 0}</td>
                <td>{p.averageRating != null ? p.averageRating.toFixed(1) : '—'}</td>
                <td>{p.reviewCount ?? 0}</td>
                <td><span className={`admin-badge ${p.status || 'active'}`}>{p.status || 'active'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminProperties;
